import React, {useEffect, useState, useCallback, useMemo} from "react";
import {inject, observer} from "mobx-react";
//local
import AgreementCardUE2021 from "../components/OurAgreements/AgreementCardUE2021";
import AgreementCardRamavtal from "../components/OurAgreements/AgreementCardRamavtal";
import MarkingsCard from "../components/OurAgreements/MarkingsCard";
import {Preloader} from "components/Preloader";
import {ourAgreementsTypes} from "constants/user.consts";

const OurAgreementsSection = inject("store")(
  observer(({store: {auth, organization}}) => {
    const [agreements, setAgreements] = useState(null);
    const [ourMarkings, setOurMarkings] = useState(null);
    const [isCreateAgreementLoading, setIsCreateAgreementLoading] = useState(false);
    const [isUpdateAgreementItemLoading, setIsUpdateAgreementItemLoading] =
      useState(false);
    const {organizationDetail, organizationMembersSelectList, markings} = organization;
    const {user, isStaff} = auth;

    const getAgreements = useCallback(
      () =>
        organization
          .getOrganizationAgreements(organizationDetail?.id)
          .then(setAgreements),
      [organization, organizationDetail.id]
    );

    // data for specific agreement
    const agreementUE2021 = useMemo(
      () => agreements?.find((item) => item.type === ourAgreementsTypes.UE2021),
      [agreements]
    );
    const agreementRamavtal = useMemo(
      () => agreements?.find((item) => item.type === ourAgreementsTypes.RAMAVTAL),
      [agreements]
    );

    // ****** WORKING WITH AGREEMENT ******
    const handleUpdateArgeement = (values) =>
      organization
        .updateOrganizationAgreement(organizationDetail.id, values)
        .then(getAgreements);

    const handleLoadAgreementFile = (file, type) =>
      organization
        .loadOrganizationAgreementFile(organizationDetail?.id, type, file)
        .then((data) => {
          getAgreements();
          return data;
        });
    const handleRemoveAgreementFile = (type, _, id) =>
      organization
        .deleteOrganizationAgreementFile(organizationDetail?.id, type, id)
        .then(getAgreements);

    // ****** WORKING WITH AGREEMENT ITEM ******
    const handleCreateArgeementItem = (type) => {
      setIsCreateAgreementLoading(true);
      organization
        .createOrganizationAgreementItem(organizationDetail.id, type, {
          name: "",
          AssignedUserId: user.id,
        })
        .then(getAgreements)
        .finally(() => setIsCreateAgreementLoading(false));
    };

    const handleUpdateArgeementItem = (values, type, agreementItemId) => {
      setIsUpdateAgreementItemLoading(true);
      organization
        .updateOrganizationAgreementItem(
          organizationDetail.id,
          type,
          agreementItemId,
          values
        )
        .then(getAgreements)
        .finally(() => setIsUpdateAgreementItemLoading(false));
    };

    const handleDeleteArgeementItem = (type, agreementItemId) =>
      organization
        .deleteOrganizationAgreementItem(organizationDetail.id, type, agreementItemId)
        .then(getAgreements);

    const handleLoadAgreementItemFile = (file, type, agreementItemId) =>
      organization.loadOrganizationAgreementItemFile(
        organizationDetail?.id,
        type,
        agreementItemId,
        file
      );

    const handleRemoveAgreementItemFile = (type, agreementItemId, fileId) =>
      organization
        .deleteOrganizationAgreementItemFile(
          organizationDetail?.id,
          type,
          agreementItemId,
          fileId
        )
        .then(getAgreements);

    const commonAgreementProps = {
      isAdminOwner: isStaff,
      ourOrganizationName: user.ActiveOrganization?.name,
      organizationName: organizationDetail.name,
      onUpdate: handleUpdateArgeement,
    };

    // ****** WORKING WITH MARKINGS ******
    const getMarkings = useCallback(
      () =>
        organization
          .getSpecificOrganizationMarkings(organizationDetail?.id)
          .then(setOurMarkings),
      [organization, organizationDetail.id]
    );

    const handleUpdateMarkings = (values) =>
      organization
        .setSpecificOrganizationMarkings(organizationDetail.id, values)
        .then(getMarkings);

    useEffect(() => {
      getAgreements();
      getMarkings();
    }, [getAgreements, getMarkings]);

    return (
      <div className="our-agreements-section">
        {!agreements && <Preloader addClass="preloader250" />}
        {!!agreements?.length && (
          <React.Fragment>
            <AgreementCardUE2021
              agreement={agreementUE2021}
              {...commonAgreementProps}
              onLoadFile={handleLoadAgreementFile}
              onRemoveFile={handleRemoveAgreementFile}
            />
            <AgreementCardRamavtal
              agreement={agreementRamavtal}
              {...commonAgreementProps}
              members={organizationMembersSelectList}
              currentUser={user}
              buttonCreateLoading={isCreateAgreementLoading}
              buttonUpdateItemLoading={isUpdateAgreementItemLoading}
              onCreateAgreementItem={handleCreateArgeementItem}
              onUpdateAgreementItem={handleUpdateArgeementItem}
              onDeleteAgreementItem={handleDeleteArgeementItem}
              onLoadAgreementItemFile={handleLoadAgreementItemFile}
              onRemoveAgreementItemFile={handleRemoveAgreementItemFile}
            />
          </React.Fragment>
        )}
        <MarkingsCard
          ourMarkings={ourMarkings}
          orgMarkings={markings}
          isAdminOwner={isStaff}
          onUpdate={handleUpdateMarkings}
        />
      </div>
    );
  })
);

export default OurAgreementsSection;
